import { render, staticRenderFns } from "./WriteOff.vue?vue&type=template&id=0c4a8b41"
import script from "./WriteOff.vue?vue&type=script&lang=ts"
export * from "./WriteOff.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports